<template>
  <div class="ThemePicker">

    <h3 class="c-black">Tema: </h3>
    <select v-model="idTheme">
      <option value="Välj ett tema" disabled>
        
      </option>
      <option v-for="theme in themes" :key="theme.id" :value="theme.id">
        {{theme.name}}
      </option>
    </select>

  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ThemePicker',
  components: {
  },
  data: function () {
    return {}
  },
  props: {
  },
  computed: {
    ...mapState('themes',[
      'themes',
    ]),
    ...mapGetters('themes',[
      'getThemeById',
    ]),
    idTheme: {
      get () { return this.$store.state.themes.idActive},
      set (value) {
        this.$router.push({ name: 'Theme', params: {route: this.getThemeById(value).route} })
      }
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .ThemePicker{
    display: flex;
    align-items: center;
    height: 20px;
    background: var(--color);
    padding: var(--main-padding);
    padding-top: 10px;
    padding-bottom: 10px;
  }

  h3{
    margin: 0 5px 0 0;
  }

</style>
